import {
    //API_GetActiveTasks,
    API_GetInspectionTasks,
    //API_GetInspections,
    API_GetObjectInspections,
    //API_PostFinishedTask,
    API_GetObjectLabels,
    API_GetActiveInspections,
    API_UpdateInspectionRow,
    API_CompleteTask
  } from '../../apiCalls/api.js';
import { useToast } from "vue-toastification";
import i18n from '../../locales/i18n'
import { recursiveSetValues } from '@/utils/mobigoObject.js';
  
const toast = useToast();

const state = () => ({
    taskdata: [],
    objectnaming:{},
    inspectiondata:[]
})

// getters
const getters = {
}

//actions
const actions = {
    
    async getTaskData({ commit }){
        const activeInspectionsResponse = await API_GetActiveInspections();
        console.log(activeInspectionsResponse);
        commit('setInspectionData', activeInspectionsResponse.data.Inspections);
        var list=[];
        for(const inspec of activeInspectionsResponse.data.Inspections){
            const tasksResponse = await API_GetInspectionTasks(inspec.TaskId);
            if(tasksResponse.data.Tasks.length === 0){
                continue;
            }
            var task = tasksResponse.data.Tasks[0];
            var dict = {};
            dict["InspectionId"] = inspec.Id
            dict["Id"] = task.Id;
            dict["Nr"] = task.Nr;
            dict["StartDate"] = task.StartDate.slice(0, 7);
            dict["Hidden"] = true;
            dict["Location"] = JSON.parse(JSON.stringify(task.Location));

            list.push(dict)
            
        }
        commit('setTaskData', list);
    },

    async getObjectNaming({ commit }){
        const response = await API_GetObjectLabels();
        commit('setObjectNaming', response.data.Labels);
    },
    
     async getInspectionsForItemAndToggleHidden({ state, commit }, item){
        if(item.Hidden){
            const index = state.taskdata.findIndex((obj => obj.Id == item.Id));
            var data = JSON.parse(JSON.stringify(state.taskdata));
            const inspectionsResponse = await API_GetObjectInspections(item.Location.Id);
            data[index]["SubObjects"] = inspectionsResponse.data.Objects[0].SubObjects;
            let remarkOptions = {};
            for(const [key, value] of Object.entries(inspectionsResponse.data.RemarkOptions)){
                remarkOptions[key] = [""].concat(value)
            }
            data[index]["RemarkOptions"] = remarkOptions

            const taskIndex = state.inspectiondata.findIndex((obj => obj.TaskId == item.Id));

            data[index]["SubObjects"] = recursiveSetValues(data[index]["SubObjects"], data[index]["RemarkOptions"], state.inspectiondata[taskIndex].Rows, item)

            commit('setTaskData', data);
            
        }
        commit('toggleHidden', item);
    },
    
    // eslint-disable-next-line 
    async updateInspection({state},data){
        let InspectionRowUpdateRequest = {
            CMIId : data.CMIId,
            InspectionStatus : data.InspectionStatus,
            Remark :data.Remark,
            Comment :data.Comment,
            RequestService : data.RequestService
            }
        // if(data.InspectionStatus === 1){
        //     InspectionRowUpdateRequest = {
        //         CMIId : data.CMIId,
        //         InspectionStatus : data.InspectionStatus,
        //         Remark :"",
        //         Comment :"",
        //         RequestService : false
        //         }  
        // }
        try{
            const result = await API_UpdateInspectionRow(InspectionRowUpdateRequest, data.Id);
            if(result.status === 200){
                return true
            }
        }
        catch(e){
            return false
        }
        return false
    },

    async addDeviations({commit, state, dispatch}, parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));
        var oldData = JSON.parse(JSON.stringify(data));
        
        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }
        if(serviceObject){
            if(parameters.value === 0){
                serviceObject["InspectionStatus"] = 0;
            }
            else{
                serviceObject["HasDeviation"] = parameters.value == 2? true:true;
                serviceObject["InspectionStatus"] = parameters.value == 1? 1:2;
                if(serviceObject["Remark"] == undefined)
                    serviceObject["Remark"] = "";
                if(serviceObject["Comment"] == undefined)
                    serviceObject["Comment"] = "";
                if(serviceObject["RequestService"] == undefined)
                    serviceObject["RequestService"] = false;
                if(serviceObject["Hidden"] == undefined)
                    serviceObject["Hidden"] = false;
            }
            if(serviceObject["InspectionStatus"] === 1){
                const result = await dispatch("updateInspection", serviceObject);
                if(!result){
                    commit('setTaskData', oldData);
                    console.log("setOldTaskData")
                    return false
                }
            }
            console.log("setTaskData")
            commit('setTaskData', data);
            return true
        }   
    },
    setRemarkOptions({state, commit},parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));
        
        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }

        if(serviceObject){
            serviceObject["RemarkOptions"] = parameters.value;
            commit('setTaskData', data);
        }
    },
    setRemark({commit, state}, parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));
        
        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }

        if(serviceObject){
            serviceObject["Remark"] = parameters.value;
            commit('setTaskData', data);
        }
    },

    setComment({commit, state}, parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));
        
        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }
        
        if(serviceObject){
            serviceObject["Comment"] = parameters.value;
            commit('setTaskData', data);
        }
    },

    setRequestService({commit, state}, parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));
        
        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }
        
        if(serviceObject){
            serviceObject["RequestService"] = parameters.value;
            commit('setTaskData', data);
        }
    },
    setHiddenServiceObject({commit, state}, parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));
        
        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }

        
        if(serviceObject){
            serviceObject["Hidden"] = !serviceObject["Hidden"];
            commit('setTaskData', data);
        }
    },
    showServiceObject({commit, state}, parameters){
        var data = JSON.parse(JSON.stringify(state.taskdata));

        const taskIndex = data.findIndex((obj => obj.Id == parameters.taskId));
        var serviceObject = undefined;
        if(parameters.indexes.length == 1){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]);
        }
        else if(parameters.indexes.length == 2){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]);
        }
        else if(parameters.indexes.length ==  3){
            serviceObject = data[taskIndex].SubObjects.find(x=> x.Id === parameters.indexes[0]).SubObjects.find(x=> x.Id === parameters.indexes[1]).SubObjects.find(x=> x.Id === parameters.indexes[2]);
        }

        if(serviceObject){
            serviceObject["Hidden"] = false;
            commit('setTaskData', data);
        }
    },

    // updateServiceObject({commit, state}, parameters){

    // },

    // async FinishTask({ state, commit },parameters){
    //     try {
    //       await API_PostFinishedTask(parameters.TaskId, parameters.data);
    //       toast.success( i18n.global.t('tasksPage.PostSuccess'));

          
    //       var data = JSON.parse(JSON.stringify(state.taskdata));
    //       for (var i = 0; i < data.length; i++) {
    //         if (data[i].Id == parameters.TaskId) {
    //             data.splice(i, 1);
    //         }
    //         commit('setTaskData', data);
    //       }
    //     }
    //     catch (e) {
    //       toast.warning( i18n.global.t('tasksPage.PostFailed')+"\r\n\r\n" +e.message);
    //     }
    // },
    async CompleteTask({dispatch}, Id){
        try {
            const response = await API_CompleteTask(Id);
            if(response.status === 200){
                toast.success( i18n.global.t('tasksPage.PostSuccess'));
                dispatch("getTaskData");
                
            }
          
        
        }
        catch (e) {
          toast.warning( i18n.global.t('tasksPage.PostFailed')+"\r\n\r\n" +e.message);
        }
    }
}

const mutations = {
   setTaskData(state, data){
    state.taskdata = data;
   },
   setInspectionData(state, data){
    state.inspectiondata = data;
   },
   setObjectNaming(state, data){
    state.objectnaming = data;
   },
   toggleHidden(state, item){
        const index = state.taskdata.findIndex((obj => obj.Id == item.Id));
        state.taskdata[index].Hidden = !state.taskdata[index].Hidden;
   },
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }